import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { setLocale } from '../../../../services/translations/actions'

function mapStateToProps(state) {
    const firstName = state.getIn(['authorization', 'user', 'firstName']) || ''
    const lastName = state.getIn(['authorization', 'user', 'lastName']) || ''
    const username = _.trim(`${firstName} ${lastName}`)

    return {
        username,
        locale: state.getIn(['translate', 'locale']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setLocaleAction: setLocale }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
